import { Component, OnInit, ViewChild } from '@angular/core';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { fadeInRight400ms } from '../../../@vex/animations/fade-in-right.animation';
import { scaleIn400ms } from '../../../@vex/animations/scale-in.animation';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { MatDialog } from '@angular/material/dialog';
import { CoronaNewTestDialogComponent } from './dialogs/corona-new-test-dialog.component';
import { CoronaNewAttendanceDialogComponent } from './dialogs/corona-new-attendance-dialog.component';
import { CoronaTestResult } from '../../entities/corona-test-result.entity';
import { CoronaOfficeAttendance } from '../../entities/corona-office-attendance.entity';
import { CoronaService } from '../../services/corona.service';
import { AppMessageService } from '../../services/message.service';
import * as dayjs from 'dayjs';
import { SpinnerService } from '../../components/spinner/spinner.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, MatSortable } from '@angular/material/sort';
import { User } from '../../entities/user.entity';
import { UserStore } from '../../stores/user.store';

@Component({
  selector: 'app-corona',
  template: `
    <div class="py-gutter container">
      <div class="flex flex-col">

        <mat-tab-group mat-align-tabs="center">
          <mat-tab label="TESTS">
            <div style="min-width: 100%; margin: 10px; margin-left:0px">
              <div class="flex-auto">
                <div class="flex">
                  <div class="flex-1"></div>
                  <div class="mat-raised-button relative flex items-center cursor-pointer select-none rounded-full px-4 py-2 hover:bg-green-light trans-ease-out"
                       matRipple (click)="addNewTestResult()">
                    <div @scaleIn class="p-2 bg-green-light text-green rounded-full ltr:mr-4 rtl:ml-4">
                      <mat-icon class="block">verified</mat-icon>
                    </div>
                    <p @fadeInRight class="font-medium text-green">New Corona Test Result</p>
                  </div>
                  <div class="flex-1"></div>
                </div>
              </div>
            </div>

            <!-- @stagger  -->
            <table mat-table matSort #sort1 [dataSource]="testDataSource" [trackBy]="myTrackById" class="w-full mat-elevation-z1">

              <ng-container matColumnDef="user">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> User </th>
                <td mat-cell *matCellDef="let element"> {{element.user.email}} </td>
              </ng-container>

              <ng-container matColumnDef="testDate">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.testDate | date: 'dd.MM H:mm'}} </td>
              </ng-container>

              <ng-container matColumnDef="testPositive">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Result</th>
                <td *matCellDef="let row" mat-cell>
                  <div class="flex">
                    <a *ngIf="row.testPositive" (click)="$event.stopPropagation()"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
                       mat-icon-button>
                      <mat-icon  size="18px">error</mat-icon>
                    </a>

                    <a *ngIf="!row.testPositive" (click)="$event.stopPropagation()"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-teal bg-teal-light"
                       mat-icon-button>
                      <mat-icon size="18px">verified_user</mat-icon>
                    </a>
                  </div>
                </td>
              </ng-container>

              <!--
              <ng-container matColumnDef="comment">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Comment </th>
                <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
              </ng-container>
              -->

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex">
                    <a (click)="showSignature(element)" style="color:grey"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary"
                       mat-icon-button>
                      <mat-icon size="18px">draw</mat-icon>
                    </a>
                    <a *ngIf="element.comment" (click)="showComment(element)" style="color:grey; margin-top:1px; margin-left: -2px;"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary"
                       mat-icon-button>
                      <mat-icon size="18px">comment</mat-icon>
                    </a>
                    <a (click)="showFiles(element)" style="color:grey"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary"
                       mat-icon-button>
                      <mat-icon size="18px">image</mat-icon>
                    </a>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsTestResults"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsTestResults;"></tr> <!-- @fadeInUp  -->
            </table>
            <mat-paginator #paginator1 [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>

          </mat-tab>

          <mat-tab label="HOURS@R18">
            <div style="min-width: 100%; margin: 10px; margin-left:0px">
              <div class="flex-auto">
                <div class="flex">
                  <div class="flex-1"></div>
                  <div
                    class="mat-raised-button relative flex items-center cursor-pointer select-none rounded-full px-4 py-1 hover:bg-primary-light trans-ease-out"
                    matRipple (click)="openNewAttendance()">
                    <div @scaleIn class="p-2 bg-primary-light text-primary rounded-full ltr:mr-4 rtl:ml-4">
                      <mat-icon class="block">maps_home_work</mat-icon>
                    </div>
                    <p @fadeInRight class="font-medium text-primary">New Office Attendance</p>
                  </div>
                  <div class="flex-1"></div>

                </div>

              </div>
            </div>
            <table @stagger mat-table #sort2 matSort [dataSource]="hoursDataSource" [trackBy]="myTrackById" class="w-full mat-elevation-z1" style="width: 100%">

              <ng-container matColumnDef="user">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> User </th>
                <td mat-cell *matCellDef="let element"> {{element.user.email}} </td>
              </ng-container>

              <ng-container matColumnDef="attendanceDate">
                <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.attendanceDate | date: 'dd.MM H:mm'}} </td>
              </ng-container>

              <!--
              <ng-container matColumnDef="Comment">
                <th mat-header-cell *matHeaderCellDef> Comment </th>
                <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
              </ng-container>
              -->

              <ng-container matColumnDef="startDate">
                <th mat-sort-header mat-header-cell *matHeaderCellDef> Start </th>
                <td mat-cell *matCellDef="let element"> {{element.startDate | date: 'H:mm'}} </td>
              </ng-container>

              <ng-container matColumnDef="endDate">
                <th mat-sort-header mat-header-cell *matHeaderCellDef> End </th>
                <td mat-cell *matCellDef="let element"> {{element.endDate | date: 'H:mm'}} </td>
              </ng-container>

              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef> Duration </th>
                <td mat-cell *matCellDef="let element"> {{getDuration(element)}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex">
                    <a (click)="showSignature(element)" style="color:grey"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary"
                       mat-icon-button>
                      <mat-icon size="18px">draw</mat-icon>
                    </a>
                    <a *ngIf="element.comment" (click)="showComment(element)" style="color:grey; margin-top: 1px; margin-left: -2px;"
                       class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary"
                       mat-icon-button>
                      <mat-icon size="18px">comment</mat-icon>
                    </a>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsAttendances"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsAttendances;"></tr>
            </table>
            <mat-paginator #paginator2 [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>

          </mat-tab>
        </mat-tab-group>

      </div>
    </div>
  `,
  animations: [
    stagger40ms,
    scaleIn400ms,
    fadeInRight400ms,
    fadeInUp400ms
  ],
  styles: [`
  `]
})
export class CoronaComponent implements OnInit {
  user: User;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20, 50];

  @ViewChild(MatPaginator) paginator1: MatPaginator;
  @ViewChild(MatSort) sort1: MatSort;
  testDataSource = new MatTableDataSource<CoronaTestResult>(null);
  testResults: CoronaTestResult[];
  columnsTestResults: string[] = ['testDate', 'testPositive', 'actions'];

  @ViewChild('paginator2', { read: MatPaginator }) paginator2: MatPaginator;
  @ViewChild('sort2', { read: MatSort }) sort2: MatSort;
  hoursDataSource = new MatTableDataSource<CoronaOfficeAttendance>(null);
  attendances: CoronaOfficeAttendance[];
  columnsAttendances: string[] = ['attendanceDate', 'startDate', 'endDate', 'duration', 'actions'];

  constructor(private dialog: MatDialog,
              private coronaService: CoronaService,
              private appMessageService: AppMessageService,
              private spinner: SpinnerService,
              private userStore: UserStore
              ) {
  }

  async ngOnInit() {
    await this.refreshView();
    this.testDataSource.paginator = this.paginator1;
    this.paginator1._intl.itemsPerPageLabel = 'Page';
    this.testDataSource.sort = this.sort1;
    this.sort1.sort(({id: 'testDate', start: 'desc'}) as MatSortable);

    this.hoursDataSource.paginator = this.paginator2;
    this.paginator2._intl.itemsPerPageLabel = 'Page';
    this.hoursDataSource.sort = this.sort2;
    this.sort2.sort(({id: 'attendanceDate', start: 'desc'}) as MatSortable);
  }

  async refreshView() {
    try {
      this.user = this.userStore.getUser() as User;
      this.spinner.show();
      if (this.user.isAdmin) {
        if (this.columnsTestResults.indexOf("user") == -1) this.columnsTestResults.unshift('user');
        if (this.columnsAttendances.indexOf("user") == -1) this.columnsAttendances.unshift('user');
        this.testResults = await this.coronaService.getAllTests();
        this.attendances = await this.coronaService.getAllAttendances();
      }
      else {
        this.testResults = await this.coronaService.getMyTests();
        this.attendances = await this.coronaService.getMyAttendances();
      }

      this.testDataSource.data = this.testResults;
      this.hoursDataSource.data = this.attendances;
      this.spinner.hide();
    }
    catch (e) {
      console.error(e);
      this.spinner.hide();
    }
  }

  async addNewTestResult() {
    await this.dialog.open(CoronaNewTestDialogComponent, {
      width: '100%',
      maxWidth: 600
    }).afterClosed().toPromise();
    await this.refreshView();
  }

  async openNewAttendance() {
    await this.dialog.open(CoronaNewAttendanceDialogComponent, {
      width: '100%',
      maxWidth: 600
    }).afterClosed().toPromise();
    await this.refreshView();
  }

  async showFiles(testResult: CoronaTestResult) {
    try {
      this.spinner.show();
      const files = await this.coronaService.getFiles(testResult);
      this.appMessageService.showImagesDialog(files);
      this.spinner.hide();
    }
    catch (e) {
      console.error(e);
      this.spinner.hide();
    }
  }

  async showComment(object: any) {
      this.appMessageService.showInfoDialog(object?.comment, "Comment");
  }

  async showSignature(object: any) {
    this.appMessageService.showImageDialog(object?.signature);
  }

  getDuration(element) {
    const startDate = dayjs(element.startDate);
    const endDate = dayjs(element.endDate);
    const diffHours = endDate.diff(startDate, 'hours');
    const diffMinutes = endDate.diff(startDate, 'minutes');
    const diff = diffHours + ':' + (diffMinutes - (diffHours * 60));
    return diff;
  }

  myTrackById(index, item){
    return item.id;
  }
}
